export default __webpack_public_path__ + "static/media/ils_20.3c60a0a3.png";